import React from 'react'

export default function BarCode(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={'1em'}
            height={'1em'}
            viewBox="0 0 512 512"
            {...props}
        >
            <title>{'Código de barras'}</title>
            <path
                fill={props.fill}
                fillRule="evenodd"
                d="M85.333 85.333v341.334H42.667V85.333h42.666Zm85.334 0v341.334H128V85.333h42.667Zm85.333 0v341.334h-42.667V85.333H256Zm213.333 0v341.334h-42.666V85.333h42.666Zm-149.333 0v341.334h-21.333V85.333H320Zm64 0v341.334h-21.333V85.333H384Z"
            />
        </svg>
    )
}

export function BarCodeBold(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={'1em'}
            height={'1em'}
            viewBox="0 0 512 512"
            {...props}
            fill="none"
            stroke="red"
            strokeWidth={0.8}
        >
            <title>{'Código de barras'}</title>
            <path
                fill={props.fill}
                fillRule="evenodd"
                d="M85.333 85.333v341.334H42.667V85.333h42.666Zm85.334 0v341.334H128V85.333h42.667Zm85.333 0v341.334h-42.667V85.333H256Zm213.333 0v341.334h-42.666V85.333h42.666Zm-149.333 0v341.334h-21.333V85.333H320Zm64 0v341.334h-21.333V85.333H384Z"
            />
        </svg>
    )
}
